$(document).ready(function(){
          if(window.masterapp.page_type == 'product'){
            variants = window.masterapp.product.variants;
            function product_page_btn_condition(select_el){
              var options = [];
              $('.single-option-selector').each(function(){
                  options.push($(this).val());
              });              
              var selected_variant_title = options.join(' / ');
              var flag = 0;
              $.each(variants, function (key, val) {
                if(val.title == selected_variant_title && !val.available){
                  $('.email-when-available').show();
                  $('#selectVariant').val(val.id).change();
                  flag = 1;
                }
              });
              if(flag == 0){
                $('.email-when-available').hide();
              }
            }
            function validateEmail(email) {
              var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return re.test(email);
            }
            if($('#mhaRnProduct').length == 0){
              $('body').append('<div id="mhaRnProduct"></div>');
            }
            var isMobile = window.matchMedia('only screen and (max-width: 767px)');
            var mha_device = 'desktop';
            if (isMobile.matches) {
              mha_device = 'mobile';
            }
            $.ajax({
              type:'GET',
              url: 'https://dev-masterapp.hulkapps.com/restock_notifier/frontend/get_product_page_btn',
              data : {store_id : window.masterapp.store_id,device: mha_device,tags: window.masterapp.product.tags},
              crossDomain: true,
              success:function(data){
                $('#mhaRnProduct').html(data);
                $.getScript('https://dev-masterapp.hulkapps.com/plugin_js/bootstrap_modal.js', function () {
                  $.ajax({
                    type:'GET',
                    url: 'https://dev-masterapp.hulkapps.com/restock_notifier/frontend/get_sign_up_form',
                    data : {store_id : window.masterapp.store_id,product_id : window.masterapp.product.id},
                    crossDomain: true,
                    success:function(data){
                      $('#mhaRnProduct').after(data);
                      if(window.masterapp.customer){
                        $('.rn-email #usr').val(window.masterapp.customer.email);
                      }
                      $(document).on('click','#mhaRnProduct .email-when-available',function(){
                        $('#RnsignUpFormModal').modal('show');
                      });
                    }
                  });
                });
                
                $(document).on('click','#signUpForm .subscribe-btn',function(e){
                  e.preventDefault();
                  var validate_email = validateEmail($('#signUpForm #usr').val()) && ($('#signUpForm #usr').val() != '');
                  var phone_no = $('#signUpForm #PhoneNo').val().trim();
                  if(phone_no != ''){
                    if(phone_no.length > 10){
                      $('#signUpForm #usr').addClass('rnpopup-error');
                    }else{
                      $('#signUpForm #usr').removeClass('rnpopup-error');
                    }
                  }
                  if(validate_email){
                    $('#signUpForm #usr').removeClass('rnpopup-error');
                  }else{
                    $('#signUpForm #usr').addClass('rnpopup-error');
                  }
                  if($('.rnpopup-error').length == 0){
                    $('#signUpForm').submit();
                    $('#signUpForm').trigger('reset');
                  }
                });
                var select_el = $('form .selector-wrapper');
                product_page_btn_condition(select_el);  
                $(document).on('change',select_el,function(){
                    product_page_btn_condition(select_el);
                });
              }
            });
          }
        });